import useDentalDataContext from 'src/packages/dental/hooks/useDentalContext';
import useTranslate from 'src/hooks/useTranslate';
import { Col, Collapse, Container, Heading, Icon, Row, themes } from '@digitools/honest-react';
import DentalText from 'src/packages/dental/constants/DentalText';
import React from 'react';
import { TEALIUM_EVENT } from 'src/constants/tealiumConstants';
import { getMemberEvent } from 'src/packages/dental/providers/DentalDataProvider';
export const AdditionalEligibilityConditions = () => {
    const { currentMember, tealiumFunction, subscriber } = useDentalDataContext();
    const memberEvent = getMemberEvent(currentMember, subscriber);
    const { t } = useTranslate();
    const dentalClauses = currentMember?.benefitsAndFrequencies?.dentalClauses;
    const CollapsedIcon = () => <Icon name='add' size='xs' className='mr-2 mt-1' color='primary'/>;
    const ExpandedIcon = () => <Icon name='subtract' size='xs' className='mr-2 mt-1' color='primary'/>;
    return (<Collapse data-testid={'dentalClauseCollapse'} title={t(DentalText.planOverviewConditionsTitle)} collapsedIcon={CollapsedIcon} expandedIcon={ExpandedIcon} theme={themes.lincoln} type='box' isOpen={false} color={'white'} headerClick={(e) => {
            if (e && e.currentTarget.ariaExpanded == 'false') {
                tealiumFunction({
                    eventAction: TEALIUM_EVENT.EVENT_ACTION.EXPAND,
                    eventName: 'additional eligibility conditions',
                    eventType: 'covered services',
                    memberEvent: memberEvent,
                });
            }
        }} data-public={true}>
      {!!dentalClauses && (<Container>
          <Row>
            <Col data-public={true}>
              {dentalClauses.map(clause => (<>
                  <Heading elemType={'h4'}>{clause.label}</Heading>
                  <p className={'mt-1 mb-3'}>{clause.value}</p>
                </>))}
            </Col>
          </Row>
        </Container>)}
    </Collapse>);
};
export default AdditionalEligibilityConditions;
